import {Route, Switch} from 'react-router-dom';
import Create from './create';

const ResourceRouter = () => (
    <Switch>
      <Route path="/aliases/new" exact component={Create} />
    </Switch>);

export default ResourceRouter;
